<template>
  <MarketplaceCard
    v-if="loaded"
    logo-alt="API access"
    description="Create API keys so your own software can read your Sera data, such as the records a webhook event names by id."
    :notice-text="readOnly ? API_KEYS_READ_ONLY_COPY : ''"
    hide-toggle
    cy-selector="marketplaceApiAccess"
  >
    <template #logo>
      <div class="mr-auto flex items-center gap-2">
        <KeyIcon class="h-8 w-8 text-gray-700" />
        <span class="text-xl font-semibold text-gray-900">API access</span>
      </div>
    </template>
    <template #configure>
      <a :href="API_ACCESS_PATH" class="link" data-cy="api-access-manage">
        Manage API keys
      </a>
    </template>
  </MarketplaceCard>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import KeyIcon from "@/images/key.svg?component";
import type { ApiKeysResponse } from "@/vuex/modules/apiKeys";
import {
  API_ACCESS_PATH,
  API_KEYS_READ_ONLY_COPY
} from "./ApiAccess/apiAccess";
import MarketplaceCard from "./MarketplaceCard.vue";

const store = useStore();

const loaded = ref(false);
const readOnly = ref(false);

async function load() {
  try {
    const response: ApiKeysResponse = await store.dispatch("fetchApiKeys");
    readOnly.value = response.meta.read_only;
    loaded.value = true;
  } catch {
    // The card stays hidden; the rest of the Marketplace still works.
    loaded.value = false;
  }
}

onMounted(load);
</script>
